import React from 'react';
import { Skeleton } from '@mui/material';

export const LoadingSkeleton = () => {
  return (
    <>
      <div className="extract-skeleton">
        <div className="skeleton-filter">
          <Skeleton sx={{ borderRadius: '8px' }} variant="rectangular" width={208} height={40} />
          <Skeleton sx={{ borderRadius: '8px' }} variant="rectangular" width={107} height={40} />
        </div>
        <Skeleton variant="rectangular" width={328} height={64} sx={{ marginBottom: '68px', borderRadius: '8px' }} />

        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px', marginTop: '24px', marginLeft: 'auto' }} width={208} height={40} />
      </div>
    </>
  );
};
